export enum CROP_STAGE_EVENT {
    CONFIRM = 'crop-stage-confirm',
    CANCEL = 'crop-stage-cancel',
    PREVIEW_STAGE_SIZE_CHANGE = 'crop-stage-preview-stage-size-change',
}
